import { Table, TableColumnsType, TableProps } from 'antd';
import dayjs from 'lib/dayjs';
import { useGetScenarioText } from 'views/Conversation/Chat/components/MessageScenario/ScenarioContext';

type RT = AeOverview.BuyerDetail;

export interface DetailTableProps extends TableProps<RT> {}

function DetailTable(props: DetailTableProps) {
  const { t, getScenarioText } = useGetScenarioText();

  const columns: TableColumnsType<RT> = [
    {
      key: 'scenario',
      title: t('aeoverview.下发场景'),
      width: 160,
      render: (_, { botReplyType, extra }) => {
        try {
          const extraInfo = JSON.parse(extra);

          return getScenarioText(botReplyType, extraInfo) || '-';
        } catch (err) {
          return '-';
        }
      },
    },
    {
      key: 'sendTime',
      dataIndex: 'sendTime',
      title: t('aeoverview.时间'),
      width: 160,
      render: (sendTime: RT['sendTime']) => dayjs(Number(sendTime)).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return <Table rowKey="sendTime" columns={columns} {...props} />;
}

export default DetailTable;
